<template>
  <div class="login-failed">
    <h2>{{ t('login.autoLoginError') }}</h2>
    <p>{{ errorDetails?.message }} - {{ errorDetails?.status }} - {{ errorDetails?.provider }}</p>
    <p class="link-text" @click="tryAgain">{{ t('login.tryAgain') }}</p>
    <p v-if="cancelButtonVisible" class="link-text" @click="cancelLogin">
      {{ t('loginForm.cancelButton.text') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { t } from '../composables/Translation'
import { getAutoLoginError, clearAutoLoginAttempt } from '../composables/auth/autoLoginGuard'
import type { AutoLoginError } from '../composables/auth/autoLoginGuard'
import router from '../router'
import { LoginRequired } from '../types/app/loginRequired'
import { useAppStore } from '../stores/appStore'
import { State } from '../types/app/state'

const appStore = useAppStore()

const errorDetails: AutoLoginError | null = getAutoLoginError()
const cancelButtonVisible = ref(
  appStore.configuration?.login.isLoginRequired !== LoginRequired.Always
)

function tryAgain() {
  clearAutoLoginAttempt()
  router.replace('login')
}

function cancelLogin() {
  clearAutoLoginAttempt()
  appStore.setState(State.Main)
  router.push({ name: 'main' })
}
</script>

<style scoped lang="scss">
.login-failed {
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  padding: 0 16px;
  text-align: center;
  color: var(--text-color);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

h2 {
  margin: 0 auto;
  font-weight: 500;
  margin-bottom: 32px;
  margin-top: 24px;
  max-width: 768px;
}

.link-text {
  align-self: stretch;
  color: var(--text-color);
  font-size: 16px;
  font-weight: 400;
  margin-top: 16px;
  line-height: 150%;
  text-decoration: underline;
}

.link-text:hover {
  cursor: pointer;
}
</style>
